import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import style from './style';

export default class Header extends Component {

	constructor(props) {
     super(props);

     this.state = {
     }

   }

	render() {
		if(location.pathname == '/'){
			return (
				<header class={style.header}>
					<h1 class={style.logo}>
						{this.props.hheading}
					</h1>
				</header>
			);
		}else{
			return (
				<header class={style.header}>
					<a href={this.props.backUrl} class={'text-left '+style.header_link}>
						<img src="/assets/arrow_left.svg" />
					</a>
					<h1 class={style.logo_center}>
						{this.props.hheading}
					</h1>
					<a href="/about" class={'text-right '+style.header_link}>
						<img src="/assets/info.svg" class={style.about_i} />
					</a>
				</header>
			);
		}

	}


}



// WEBPACK FOOTER //
// ./components/header/index.js